/** Keep the in-report dialog below the existing sticky header, without changing the shell. */
export function revealReportDialog(kind: 'report-evidence' | 'report-record'): void {
    const dialog = document.querySelector<HTMLElement>(`.clinic-report [data-testid="${kind}"]`);
    if (!dialog) return;
    const box = dialog.getBoundingClientRect();
    const top = Math.max(0, document.querySelector('.ac-app-topbar')?.getBoundingClientRect().bottom ?? 0) + 12;
    const available = window.innerHeight - top - 12;
    const shift = box.top < top ? box.top - top
        : box.height <= available && box.bottom > window.innerHeight - 12 ? box.bottom - window.innerHeight + 12 : 0;
    if (shift) window.scrollTo({ top: Math.max(0, window.scrollY + shift), behavior: 'instant' });
}
export function restoreReportOpener(opener: HTMLElement | null, scroll: number): void {
    if (!opener?.isConnected || opener.closest('[inert]')) return;
    opener.focus({ preventScroll: true });
    window.scrollTo({ top: scroll, behavior: 'instant' });
}
